// extracted by mini-css-extract-plugin
export default {"invalid-error":"PoolShipForm_invalid-error__Uxcrh"};